export default {_name:'cart.steps',module:'Field',view:'Element/Cart/Steps',options:{xs:12}}